(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    (() => {
    const tagName = 'sticky-buy-buttons';
    if (customElements.get(tagName)) return;

    class StickyBuyButtons extends HTMLElement {
      static observedAttributes = ['data-sticky-desktop'];

      #desktop = window.matchMedia('(min-width: 750px)');
      #host = null;
      #shell = null;
      #frame = 0;
      #placeholder = null;
      #moving = false;
      #initialized = false;
      #resizeObserver = new ResizeObserver(() => this.#schedule());
      #mutationObserver = new MutationObserver(() => this.#schedule());
      #handleViewportChange = () => this.#schedule();

      connectedCallback() {
        if (this.#moving) {
          this.#moving = false;
          return;
        }

        if (!this.#initialized) {
          this.#desktop.addEventListener('change', this.#handleViewportChange);
          this.#initialized = true;
        }
        this.#schedule();
      }

      disconnectedCallback() {
        if (this.#moving) return;

        this.#desktop.removeEventListener('change', this.#handleViewportChange);
        this.#initialized = false;
        cancelAnimationFrame(this.#frame);
        this.#resizeObserver.disconnect();
        this.#mutationObserver.disconnect();
        this.#placeholder?.remove();
        this.#placeholder = null;
        this.#host = null;
        this.#shell = null;
      }

      attributeChangedCallback() {
        if (this.isConnected) this.#schedule();
      }

      #schedule() {
        cancelAnimationFrame(this.#frame);
        this.#frame = requestAnimationFrame(() => this.#sync());
      }

      #resolveScrollHost() {
        if (this.#isFooterActive()) return this.#host;

        let candidate = this.parentElement;

        while (candidate) {
          const overflowY = getComputedStyle(candidate).overflowY;
          if (overflowY === 'auto' || overflowY === 'scroll') return candidate;
          candidate = candidate.parentElement;
        }

        return null;
      }

      #observeHost(host) {
        if (host === this.#host) return;

        if (this.#isFooterActive()) this.#restoreToFlow();
        this.#resizeObserver.disconnect();
        this.#mutationObserver.disconnect();
        this.#host = host;
        this.#shell = host?.parentElement?.matches('[data-fit-panel-shell]') ? host.parentElement : null;
        this.#resizeObserver.observe(this);

        if (host) {
          this.#resizeObserver.observe(host);
          if (this.#shell) this.#resizeObserver.observe(this.#shell);
          this.#mutationObserver.observe(host, { childList: true, subtree: true });
        }
      }

      #sync() {
        const footerActive = this.#isFooterActive();
        const host = footerActive ? this.#host : this.#resolveScrollHost();
        if (!footerActive) this.#observeHost(host);

        const enabled =
          this.dataset.stickyDesktop === 'true' &&
          this.#desktop.matches &&
          host &&
          this.#shell;
        if (!enabled) {
          this.#deactivate();
          return;
        }

        const activeFooter = this.#shell.querySelector(`${tagName}[data-sticky-footer-active='true']`);
        if (activeFooter && activeFooter !== this) {
          this.#deactivate();
          return;
        }

        if (!footerActive) {
          const firstEnabled = [...host.querySelectorAll(`${tagName}[data-sticky-desktop='true']`)]
            .find((candidate) => candidate.#resolveScrollHost() === host);
          if (firstEnabled !== this) {
            this.#deactivate();
            return;
          }
        }

        const overflows = footerActive ? this.#panelNeedsFooter() : host.scrollHeight > host.clientHeight + 1;

        if (!overflows) {
          this.#deactivate();
          return;
        }

        if (!footerActive) this.#moveToFooter();
      }

      #isFooterActive() {
        return Boolean(
          this.#placeholder?.isConnected &&
          this.#shell &&
          this.parentElement === this.#shell
        );
      }

      #panelNeedsFooter() {
        if (!this.#host || !this.#shell) return false;

        const shellStyle = getComputedStyle(this.#shell);
        const paddingBlock =
          (Number.parseFloat(shellStyle.paddingBlockStart) || 0) +
          (Number.parseFloat(shellStyle.paddingBlockEnd) || 0);
        const availableHeight = Math.max(0, this.#shell.clientHeight - paddingBlock);
        const footerHeight = this.getBoundingClientRect().height;
        const footerGap = Number.parseFloat(
          this.style.getPropertyValue('--fit-sticky-buy-buttons-footer-gap')
        ) || 0;

        return this.#host.scrollHeight + footerHeight + footerGap > availableHeight + 1;
      }

      #moveToFooter() {
        if (!this.#host || !this.#shell || this.#isFooterActive()) return;

        this.#placeholder = document.createElement('span');
        this.#placeholder.hidden = true;
        this.#placeholder.setAttribute('aria-hidden', 'true');
        this.#placeholder.dataset.fitStickyBuyButtonsPlaceholder = this.dataset.blockId || '';
        this.before(this.#placeholder);

        const hostStyle = getComputedStyle(this.#host);
        const footerGap = hostStyle.rowGap === 'normal' ? '0px' : hostStyle.rowGap;
        this.style.setProperty('--fit-sticky-buy-buttons-footer-gap', footerGap);
        this.dataset.stickyFooterActive = 'true';

        this.#moving = true;
        this.#shell.append(this);
      }

      #restoreToFlow() {
        if (!this.#placeholder) return;

        if (this.#placeholder.isConnected) {
          this.#moving = true;
          this.#placeholder.before(this);
        }
        this.#placeholder.remove();
        this.#placeholder = null;
        delete this.dataset.stickyFooterActive;
        this.style.removeProperty('--fit-sticky-buy-buttons-footer-gap');
      }

      #deactivate() {
        if (this.#isFooterActive()) this.#restoreToFlow();
        delete this.dataset.stickyFooterActive;
        this.style.removeProperty('--fit-sticky-buy-buttons-footer-gap');
      }
    }

    customElements.define(tagName, StickyBuyButtons);
  })();
  } catch(e) { console.error(e); }
})();

})();
